import { render, staticRenderFns } from "./FormAccountType.vue?vue&type=template&id=42a43a82"
import script from "./FormAccountType.vue?vue&type=script&lang=js"
export * from "./FormAccountType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports